// eslint-disable-next-line
import SchulteLetters from "./container/SchulteLetters"
// eslint-disable-next-line
import { actions, actions as schulteLettersContainerActions } from './actions'

export const NAME = 'SCHULTELETTERS'
export const types = {
  GET_SUBSCRIPTION_REQUEST: `${NAME}/GET_SUBSCRIPTION_REQUEST`,
}

export const initialState = {
  lvlInfo: false,
  schulteType: {},
  autoHelp: {
    remainingForAutoHelp: 2
  },
  lastLvlUpdate: "",
  currentLvl: "START",
  toFindPosition: 0,
  toFindMatrix: ['A'],
  lettersMatrix: [],
  currentRound: 0,
  points: 0,
  timeLeft: 60,
  countDown: 3,
  wrongAnswers: 0,
  exersizeState: "startScrean"
}



export function reducer(state = initialState, action) {
  switch (action.type) {
    case "PREEXERSIZE":
      return {
        ...state,
        exersizeState: "preexersize",        
        currentLvl: action.currentLvl
      };
    case "INCREMENT_COUNTDOWN":
      return {
        ...state,
        countDown: state.countDown - 1,
      };
    case "INCREMENT":
      return {
        ...state,
        timeLeft: state.timeLeft - 1
      }
    case "SET_INCREMENT_COUNT_DOWN":
      return {
        ...state,
        countDown: action.newCountDown
      }
    case "START_GAME":
      return {
        ...state,
        exersizeState: "gameStarted"
      }
    case "GENERATE_MATRIX":      
        return {
          ...state,
          toFindPosition: 0,
          toFindMatrix: action.toFindMatrix,
          lettersMatrix: action.lettersMatrix
        }
    case "CELL_CLICK": {      
      return {
        ...state,
        toFindPosition: action.toFindPosition,
        lettersMatrix: action.lettersMatrix,
        points: action.points,
        wrongAnswers: action.wrongAnswers,
        timeLeft: action.timeLeft,
        exersizeState: action.exersizeState,
        lvlInfo: action.lvlInfo
      }
    }
    case "GAME_OVER": {
      return {
        ...state,
        exersizeState: 'gameOver'
      }
    }
    case "SHOW_GAME_OVER_SCREAN": {
      return {
        ...state,
        exersizeState: 'scoreScrean'
      }
    }
    case "NEW_ROUND": {
      return {
        ...state,
        lvlInfo: action.lvlInfo,
        currentLvl: action.currentLvl,
        currentRound: action.currentRound,
        lastLvlUpdate: action.lastLvlUpdate
      }
    }
    case "SET_SCHULTE_TYPE": {
      return {
        ...state,
        schulteType: action.schulteType,
        lvlInfo: {
          ...state.lvlInfo,
          ...action.lvlInfo
        }
      }
    }
    default:
      return { ...state }
  }
}
